import React, { useState } from "react";
import { connect } from "react-redux";
import { alertConstants, getAlertData } from "../../helper/sweet-alert";
import SweetAlert from "react-bootstrap-sweetalert";
import { IRateFeedback } from "../../models/common/IUserProfile";
import { IPortalRating } from "../../models/common/IPortalRating";
import { createPortalRating } from "../../action/common/commonActionCreator";
import Joi from "joi";
import { validateFields } from "../../helper/joi-validation";

const FeedbackRating = (props: IRateFeedback) => {
  const { setShowRateFeedback, createPortalRating } = props;

  const initialData: IPortalRating = {
    rating: 0,
    suggestion: "",
  };

  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [showAlertCancel, setShowAlertCancel] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>(undefined);

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };
  const [data, setData] = useState(initialData);

  const onClose = () => {
    setShowRateFeedback(false);
  };

  const onSave = () => {
    const validationErrors = validateFields(data, schema);
    if (validationErrors === undefined) {
      const formdata = new FormData();
      formdata.append("rating", data.rating.toString());
      formdata.append("suggestion", data.suggestion.toString());
      if (data.rating != 0) {
        createPortalRating(data, setAlert);
      }
    }
    else {
      setErrors(validationErrors);
    }

  };

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else {
      setShowRateFeedback(false);
    }
  };

  const onChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    errors && delete errors[event.target.name];
    if (event.target.name === "rating") {
      setData({ ...data, rating: Number(event.target.value) });
    } else if (event.target.name === "suggestion") {
      setData({ ...data, suggestion: event.target.value });
    }
  };

  const schema = Joi.object().keys({
    rating: Joi.number().min(1).max(5).required().label("Please provide a valid rating"),
  });

  return (
    <>
      <div className="modal-body">
        <h2>Rate this application</h2>
        <p>
          Click on a star to change your rating 1 - 5, where 5 = Great! and 1 =
          Very Bad.
        </p>
        <div className="ratings mb-3">
          <div className="star-rating">
            {[5, 4, 3, 2, 1].map((star) => (
              <React.Fragment key={star}>
                <input
                  type="radio"
                  id={`${star}-stars`}
                  name="rating"
                  value={star}
                  checked={data.rating === star}
                  onChange={onChange}
                />
                <label htmlFor={`${star}-stars`} className="star">
                  &#9733;
                </label>
              </React.Fragment>
            ))}
          </div>
          {errors?.rating && (
            <div className="text-danger">{errors.rating}</div>
          )}
        </div>
        <div className="form-group mb-0">
          <label htmlFor="suggestion">
            Do you have any suggestions to improve our portal?
          </label>
          <textarea
            id="suggestion"
            name="suggestion"
            value={data.suggestion}
            onChange={onChange}
            className="form-control"
            required
          ></textarea>
        </div>
      </div>
      <div className="modal-footer mb-2 pt-2">
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {
            onSave();
          }}
        >
          Submit
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          data-bs-dismiss="modal"
          onClick={() => {
            onClose();
          }}
        >
          Cancel
        </button>
      </div>

      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={showAlertCancel}
        onCancel={() => {
          setShowAlert(false);
          setShowAlertCancel(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={showAlertCancel ? "Yes" : "Ok"}
      ></SweetAlert>
    </>
  );
};

const mapDispatchToProps = {
  createPortalRating: (data: any, callback: Function) =>
    createPortalRating(data, callback),
};

export default connect(null, mapDispatchToProps)(FeedbackRating);
